import { Modal } from '@sequencehq/core-components'
import Loading from 'components/Loading'
import { ProductPriceContent } from 'modules/Products/drawers/ProductPrice/components/ProductPriceContent'
import { APIPrice } from 'Products/types'
import { Product } from 'modules/Products/types'

export const ProductPrice = (props: {
  onClose: () => void
  price?: APIPrice
  product?: Product
  showBillingScheduleInfo?: boolean
}) => {
  const { price, onClose, product } = props

  return (
    <Modal
      isOpen
      variant="drawer"
      width="550px"
      onClose={onClose}
      data-testid="productPrice.drawer"
    >
      <Modal.Header
        showCloseButton
        withBorder
        data-testid="productPrice.header"
      >
        Price variant {price ? `for ${price.name}` : ''}
      </Modal.Header>
      <Modal.Content padding={0}>
        {!price ? (
          <Loading />
        ) : (
          <ProductPriceContent
            price={price}
            product={product}
            showBillingScheduleInfo={props.showBillingScheduleInfo}
          />
        )}
      </Modal.Content>
    </Modal>
  )
}
